<template>
  <div>
    <div class="bg-color-red userform_top"></div>
    <div class="userform">
      <h3 class="userform_title">申请人信息</h3>
      <div class="userform_item userform_item_red">
        <input type="text" placeholder="姓名" v-model.trim="formList.name"/>
        <p class="userform_item_label" v-if="formlabel.warnstatus == 1">{{formlabel.text}}不能为空</p>
      </div>
      <div class="userform_item userform_item_red">
        <input type="number" placeholder="手机号码" v-model.trim="formList.phone"/>
        <p class="userform_item_label" v-if="formlabel.warnstatus == 2">{{formlabel.text}}不能为空</p>
      </div>
      <div class="userform_item userform_item_red">
        <input type="number" placeholder="验证码" max="999999" v-model.trim="formList.verifi" class="yzm_number"/>
        <div class="yzm" :class="{'actived' : yzm.yzmstatus }" @click="yzmClick()">{{yzm.text}}</div>
        <p class="userform_item_label" v-if="formlabel.warnstatus == 3">{{formlabel.text}}不能为空</p>
      </div>
      <div class="userform_item">
        <input type="text" placeholder="请输入您的邀请码" maxlength="12" v-model.trim="formList.agentcode"/>
        <!-- <div class="agentcode">请输入邀请码</div> -->
      </div>
      <div class="userform_item userform_item_agent userform_item_red" >
        <div @click="openAgentLevel()" class="agent_level_info">
          <div v-if="checklevel">请选择您想申请的代理等级</div>
          <div v-else>lv{{formList.agentlevelname}} {{formList.agentlevelamount}}</div>
          <span class="iconfont icon-jiantou"></span>
        </div>
        <div class="agent_level_child" v-show="agentlevelshow">
          <div class="agent_level_name" v-for="(item, index) in agentarray" :key="index" @click="closeAgentLevel(index)"><span>Lv</span>{{item.name}}：{{item.amount}}</div>
        </div>
      </div>
      <div class="userform_item userform_item_textarea">
        <textarea placeholder="备注信息" cols="30" rows="6" v-model="formList.remark"></textarea>
      </div>
      <button class="userform_submit bg-color-red" @click="userformsubmit()">
        提交申请
      </button>
    </div>
    <div class="userform_description">
      <p>温馨提示：</p>
      <van-uploader :after-read="afterRead" />
      {{ description }}
    </div>
  </div>
</template>
<script>
import { VUE_APP_API_URL } from "@utils";
import {
  registerVerify,
  register,
  getCodeApi,
  userform
} from "@api/user";
import Uploader from 'vant/lib/uploader';
import 'vant/lib/uploader/style';
import 'vant/lib/icon/index.css';


export default {
  components:{
    [Uploader.name]:Uploader
  },
  data: function() {
    return {
      formList:{
        name:'',
        phone:'',
        agentcode: '',
        verifi:'',
        remark:'',
        agentlevelname: '',
        agentlevelamount: '',
      },
      formlabel: {
        warnstatus: 0,
        text: '姓名'
      },
      keyCode: '',
      type: '',
      codeVal: '',
      checked: false,
      yzm: {text: '发送验证码',yzmstatus: false},
      yzmtime: 60,
      setyamtime: {},
      description: "请填写您的实名信息方便我们联系到您",
      agentlevelshow: false,
      checklevel: true,
      agentarray:[
        {name: '城市英雄', amount: '30台', },
        {name: '城市掌门', amount: '100台', },
        {name: '城市盟主', amount: '200台', },
        {name: '财富650', amount: '', }
      ]
    }
  },
  mounted: function() {
    this.getCode();
  },
  methods: {
    openAgentLevel () {
      this.agentlevelshow = !this.agentlevelshow;
      console.log(this.formList.agentlevelname)
    },
    closeAgentLevel (index) {
      this.checklevel = false;
      this.formList.agentlevelname = this.agentarray[index].name;
      this.formList.agentlevelamount = this.agentarray[index].amount;
      this.agentlevelshow = false;
    },
    getCode() {
      getCodeApi()
        .then(res => {
          this.keyCode = res.data.key;
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
    },
    async code() {
      let that = this;
      that.type = "register";
      await registerVerify({
        phone: that.formList.phone,
        type: that.type,
        key: that.keyCode,
        code: that.codeVal
      })
        .then(res => {
          if( that.yzm.text === '发送验证码' || res.msg === '发送成功') {
            that.yzm.yzmstatus = true;
            that.yzm.text = '已发送('+ that.yzmtime +')';
            clearInterval(that.setyzmtime);
            that.setyzmtime = setInterval(() => {
              that.yzmtime--;
              that.yzm.yzmstatus = true;
              that.yzm.text = '已发送('+ that.yzmtime +')';
              if( that.yzmtime <= 0){
                that.yzm.yzmstatus = false;
                that.yzm.text = '发送验证码';
                that.yzmtime = 60;
                clearInterval(that.setyzmtime);
              }
            }, 1000);
          }
          that.$dialog.success(res.msg);
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
            
    },
    async userformsubmit() {  
      if(!this.formList.name){
        this.formlabel.warnstatus = 1;
        this.formlabel.text = '姓名';
      }else if(!this.formList.phone){
        this.formlabel.warnstatus = 2;
        this.formlabel.text = '电话';
      }else if(!this.formList.verifi){
        this.formlabel.warnstatus = 3;
        this.formlabel.text = '验证码';
      }else{
        this.formlabel.warnstatus = 0;
        // 信息均已，向服务器传递申请人信息
        userform ({
          name: this.formList.name,
          phone: this.formList.phone,
          agentcode: this.formList.agentcode,
          verifi: this.formList.verifi,
          content: this.formList.remark,
          agentlevel: this.formList.agentlevelname
        })
        .then(res => {
          this.$dialog.success(res.msg);
          this.$router.go(-1);
        })
        .catch(res => {
          if (res.data.status === 402) {
            this.$dialog.error(res.msg);
          }else if (res.data.status === 400) {
            this.$dialog.error(res.msg);
          }
          this.$dialog.error(res.msg);
        });
      }
    },
    yzmClick: function () {
      this.code();
    }
  },
};
</script>
<style scoped>
.userform_top {
  width: 100%;
  height: 150px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  background: linear-gradient(0deg, #434343, #000000);
  background: -webkit-linear-gradient(0deg, #434343, #000000);
  background: -moz-linear-gradient(0deg, #434343, #000000);
  background: -ms-linear-gradient(0deg, #434343, #000000);
}
.userform {
  font-size: 15px;
  box-sizing: border-box;
  border-radius: 0.8em;
  padding: 1.6em;
  width: 85%;
  margin: 50px auto 0;
  background: #ffffff;
  box-shadow: 2px 2px 16px 0 rgba(0, 0, 0, 0.08);
  color: #000;
  position: relative;
  z-index: 1000;
}
.userform .userform_title {
  text-align: center;
  font-size: 20px;
  padding-bottom: 1.2em;
}
.userform .userform_item {
  width: 100%;
  margin: 0 auto;
  margin-bottom: 1.6em;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.userform .userform_item_red:before{
  content: "*";
  display: block;
  padding: 0 0.4em;
  color: rgb(223, 53, 53);
  position: absolute;
}
.userform .userform_item .yzm{
  width: 7.6em;
  padding: 0 0.6em;
  background: #80cdd4;
  color: #ffffff;
  margin-left: 0.6em;
  line-height: 2.4em;
  text-align: center;
}
.userform .userform_item_agent {
  border-bottom: 1px solid #80cdd4;
  color: #80cdd4;
}
.userform  .userform_item_agent .agent_level_info {
  width: 100%;
  display: flex;
  justify-content: space-between;
  line-height: 2.4em;
  padding-left: 1.2em;
}
.userform .userform_item_agent .agent_level_child {
  box-sizing: border-box;
  width: 100%;
  position: absolute;
  top: 2.4em;
  z-index: 1000;
  color: #000;
  background: #ffffff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  line-height: 2em;
  padding: 1em;
  border-radius: 0 0 4px 4px;
  border-top: 1px solid #80cdd4;
}
.userform .userform_item_agent .agent_level_name span{
  display: inline-block;
  color: #80cdd4;
  font-weight: 600;
  margin-right: 0.3em;
}
.userform .userform_item .yzm.actived{
  background: #f2f2f2;
  color: #999999;
}
.userform .userform_item .yzm_number{
  width: 8em;
  text-align: center;
  letter-spacing: 1px;
}
.userform .userform_item .agentcode{
  width: 10.6em;
  text-align: center;
  color: #000;
  margin-right: 0.4em;
}
.userform .userform_item input,
.userform .userform_item textarea {
  width: 100%;
  display: block;
  background: #f5f5f5;
  border-radius: 4px;
  color: #000;
  line-height: 1.6em;
  padding: 0.6em 0.6em;
}
.userform .userform_item input {
  line-height: 2.4em;
  padding: 0 1em;
}
.userform .userform_item_textarea.userform_item {
  align-items: flex-start;
}
.userform .userform_item_bottom {
  display: flex;
}
.userform .userform_item .userform_agreement {
  display: flex;
}
.userform .userform_item .userform_agreement span {
  color: #80cdd4;
}
.userform_item_label{
  font-size: 12px;
  color: rgb(255, 70, 70);
  position: absolute;
  left: 0;
  bottom: -2em;
  z-index: 1000;
  text-indent: 1em;
  line-height: 2em;
  text-align: left;
}
.userform_submit {
  margin: 0 auto;
  display: block;
  width: 80%;
  line-height: 2.4em;
  border-radius: 1.2em;
  background: linear-gradient(90deg, #80cdd4, #80cdd4);
  background: -webkit-linear-gradient(90deg, #80cdd4, #80cdd4);
  background: -moz-linear-gradient(90deg, #80cdd4, #80cdd4);
  background: -ms-linear-gradient(90deg, #80cdd4, #80cdd4);
  text-align: center;
  font-weight: 600;
  color: #452f0d;
}
.userform_description {
  width: 90%;
  margin: 0 auto;
  font-size: 14px;
  padding-top: 2em;
  line-height: 1.6em;
  color: #80cdd4;
}
.userform_description p {
  font-size: 1.2em;
  display: inline-block;
  font-weight: 600;
}
</style>
